export const MANAGE_PRODUCTION_FETCHING_MENUS =
  'MANAGE_PRODUCTION_FETCHING_MENUS';
export const MANAGE_PRODUCTION_SET_MENUS = 'MANAGE_PRODUCTION_SET_MENUS';
export const MANAGE_PRODUCTION_SET_ERROR = 'MANAGE_PRODUCTION_SET_ERROR';
export const MANAGE_PRODUCTION_CLEAR_ERROR = 'MANAGE_PRODUCTION_CLEAR_ERROR';
export const MANAGE_PRODUCTION_FETCHING_PRODUCTION_RECORDS =
  'MANAGE_PRODUCTION_FETCHING_PRODUCTION_RECORDS';
export const MANAGE_PRODUCTION_SET_PRODUCTION_RECORDS =
  'MANAGE_PRODUCTION_SET_PRODUCTION_RECORDS';
export const MANAGE_PRODUCTION_CLEAR_STATE = 'MANAGE_PRODUCTION_CLEAR_STATE';

export const MANAGE_PRODUCTION_CLOSE_PRODUCTION_RECORD_LOADING =
  'MANAGE_PRODUCTION_CLOSE_PRODUCTION_RECORD_LOADING';
export const MANAGE_PRODUCTION_CLOSE_PRODUCTION_RECORD_SUCCESS =
  'MANAGE_PRODUCTION_CLOSE_PRODUCTION_RECORD_SUCCESS';
export const MANAGE_PRODUCTION_CLOSE_PRODUCTION_RECORD_ERROR =
  'MANAGE_PRODUCTION_CLOSE_PRODUCTION_RECORD_ERROR';

export const MANAGE_PRODUCTION_REOPEN_PRODUCTION_RECORD_LOADING =
  'MANAGE_PRODUCTION_REOPEN_PRODUCTION_RECORD_LOADING';
export const MANAGE_PRODUCTION_REOPEN_PRODUCTION_RECORD_SUCCESS =
  'MANAGE_PRODUCTION_REOPEN_PRODUCTION_RECORD_SUCCESS';
export const MANAGE_PRODUCTION_REOPEN_PRODUCTION_RECORD_ERROR =
  'MANAGE_PRODUCTION_REOPEN_PRODUCTION_RECORD_ERROR';

export const MANAGE_PRODUCTION_SET_CLOSE_PRODUCTION_SUCCESSFUL =
  'MANAGE_PRODUCTION_SET_CLOSE_PRODUCTION_SUCCESSFUL';

  export const MANAGE_PRODUCTION_SET_REOPEN_PRODUCTION_SUCCESSFUL =
  'MANAGE_PRODUCTION_SET_REOPEN_PRODUCTION_SUCCESSFUL';



// WEBPACK FOOTER //
// ./src/pages/manageproduction/state/manageproduction/types.js